import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectContentCounts, selectContentCountsUpToDate } from '~selectors/ContentCountsSelector';
import { CompositeSessionInfoSelectors, selectSessionSite, SessionSiteSelectors } from '~selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '~selectors/SpaceInfoSelectors';

import { contentCountsRequest } from '../../app/actions/spaces/ContentCountsActions';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { selectEditingFlowsEnabled,selectFlowsOnSiteEnabled } from '../../flow/selectors/FlowSelectors';
import { DatasourceSpace, DatasourceSpaceDispatchProps, DatasourceSpaceStateProps } from './DatasourceSpace';

const mapStateToProps: MapStateToProps<DatasourceSpaceStateProps> = (state: AppState) => ({
  flowsOnSiteEnabled: selectFlowsOnSiteEnabled(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  editingFlowsEnabled: selectEditingFlowsEnabled(state),
  spaceInfo: selectSpaceInfo(state),
  urls: siteUrlsSelector(state),
  contentCounts: selectContentCounts<'datasource'>(state, 'datasource'),
  contentCountsUptoDate: selectContentCountsUpToDate(state),
  siteId: selectSessionSite(state).id,
  siteUrlName: SessionSiteSelectors.siteUrlName(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state)
});

const mapDispatchToProps: MapDispatchToProps<DatasourceSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedDatasourceSpace = connect(mapStateToProps, mapDispatchToProps)(DatasourceSpace);
